import * as React from "react";
import { useEffect } from "react";
import { container, description, readMore } from "./ParagraphBody.module.scss";
import { Container } from "react-bootstrap";

export const StyledContainer: React.FC<any> = (props) => {
  return (
    <Container fluid="sm" className={container}>
      {props.children}
    </Container>
  );
};

export const Description = (props: {
  text: string;
  themeColor: string;
}): JSX.Element => {
  const extractDescriptionContent = (description: string) => {
    const span = document.createElement("span");
    span.innerHTML = description;
    return span.textContent || span.innerText;
  };

  const TRIMLENGTH = 375;
  const aboutText = props.text || "";
  const content = extractDescriptionContent(aboutText);
  const isDescToTrim =
    content.length > TRIMLENGTH && !aboutText.toLowerCase().includes("<table");
  const [isFullText, setIsFullText] = React.useState(false);

  const handleReadMore = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsFullText(true);
  };

  const handleReadLess = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsFullText(false);
  };

  useEffect(() => {
    if (isDescToTrim) {
      setIsFullText(false);
    } else {
      setIsFullText(true);
    }
  }, []);

  return (
    <>
      <div className={description}>
        <div
          className={!isFullText ? "content" : ""}
          dangerouslySetInnerHTML={{ __html: aboutText }}
        />
      </div>
      {aboutText?.length > 375 ? (
        !isFullText ? (
          <a
            className={readMore}
            id="about-read-more"
            onClick={handleReadMore}
            aria-expanded={false}
            aria-label={"Read More"}
            href="#"
            style={{
              textDecorationColor: props.themeColor,
            }}
          >
            Read More +
          </a>
        ) : (
          <a
            className={readMore}
            id="about-read-less"
            onClick={handleReadLess}
            aria-expanded={true}
            aria-label={"Read Less"}
            href="#"
            style={{
              textDecorationColor: props.themeColor,
            }}
          >
            Read Less -
          </a>
        )
      ) : null}
    </>
  );
};
